export const isDevelopment = import.meta.dev;
export const isBrowser = import.meta.client;
export const isSSR = import.meta.server;
